import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

const useIsTimeFormat24H = () => {
  const { access } = useCurrentSession()

  return {
    isTimeFormat24H: access.timeFormat === 24,
  }
}

export default useIsTimeFormat24H
